var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.09376 1.59376L8.0001 5.39069L14.3283 1.59376M2.93752 10.7284C2.00553 10.7284 1.25 9.97288 1.25 9.04088V2.43753C1.25 1.50553 2.00553 0.75 2.93752 0.75H13.0627C13.9947 0.75 14.7502 1.50553 14.7502 2.43753V9.04088C14.7502 9.97288 13.9947 10.7284 13.0627 10.7284H2.93752Z",
    stroke: "#616874",
    strokeWidth: 1.50002,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.2af55bbc51eb04bd98c4d6f41942911f.svg";
export { ForwardRef as ReactComponent };